import { api } from "../client";
import { Config, ConfigMutate } from "../types";
import {
  UserFields,
  PartialCommissionExtraFields,
  PartialCommissionFields,
  UserExtraFields,
} from "../schema";

type ApiRequestConfig = Config<UserFields, UserExtraFields>;
type ApiRequestConfigMutate = ConfigMutate<
  PartialCommissionFields,
  PartialCommissionExtraFields
>;

export const getUsers = (config?: ApiRequestConfig) => {
  return api.get<UserFields, UserExtraFields>(`user_users`, config);
};

export const getUser = (id: number, config?: ApiRequestConfig) => {
  return api.get<UserFields, UserExtraFields>(`user_users/${id}`, config);
};

export const updateUser = (id: number, config?: ApiRequestConfigMutate) => {
  return api.update<UserFields, UserExtraFields>(`user_users/${id}`, config);
};

export const deleteUser = (id: number) => {
  return api.remove<UserFields, UserExtraFields>(`user_users/${id}`);
};
